import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.$gray200};
  cursor: pointer;
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 2px 8px ${(props) => props.theme.$black}1f;
  }

  .card-location {
    color: ${(props) => props.theme.$gray700};
  }

  .card-object {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }

  .material-icons {
    font-size: 16px;
  }

  .badge-dark {
    font-size: 12px;
    background: ${(props) => props.theme.$steel_blue} !important;
  }
`;
